import {
  dangerHighlightColor,
  dangerTextColor,
  warnHighlightColor,
  warnTextColor
} from '../../../lib/theme';
import { IAdHocCommunicationPreview } from '../../../lib/types';
import { IPreviewRecipientOption } from './preview-panel.types';

// The server escapes values/fallbacks and wraps unresolved tokens in
// <mark data-issue>; this only styles those marks, never tokenizes.
const PREVIEW_DOC_STYLES = `
  html, body { margin: 0; padding: 0; }
  body {
    padding: 14px;
    background: #fff;
    color: #222;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;
  }
  p { margin: 0 0 0.5em; }
  h1, h2, h3, h4, h5, h6 { margin: 0.7em 0 0.3em; line-height: 1.25; }
  ul, ol { margin: 0 0 0.5em; padding-left: 1.6em; }
  li { margin: 0.15em 0; }
  a { color: #1a73e8; }
  img { max-width: 100%; }
  mark[data-issue] { border-radius: 2px; padding: 0 2px; }
  mark[data-issue="unknown"] { background: ${dangerHighlightColor}; color: ${dangerTextColor}; }
  mark[data-issue="missing-fallback"] { background: ${warnHighlightColor}; color: ${warnTextColor}; }
`;

// Wraps the server-rendered body in a minimal, script-free doc for the sandboxed
// preview iframe (the empty sandbox is the security boundary).
export const buildEmailPreviewDoc = (bodyHtml?: string): string =>
  `<!DOCTYPE html><html><head><meta charset="utf-8">`
  + `<meta name="viewport" content="width=device-width, initial-scale=1">`
  + `<style>${PREVIEW_DOC_STYLES}</style></head>`
  + `<body>${bodyHtml || ''}</body></html>`;

// The recipient a preview / test-source render is currently for: an explicit pick,
// else the server-resolved default (first) recipient off the preview. Null = none.
export const resolvePreviewRecipient = (
  selected: IPreviewRecipientOption | null,
  preview?: IAdHocCommunicationPreview
): IPreviewRecipientOption | null => {
  if (selected) return selected;
  if (preview && preview.playerAssessmentId) {
    return { key: preview.playerAssessmentId, label: preview.playerName || '' };
  }
  return null;
};
